import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { useFormContext } from "react-hook-form";

const WarehouseDetailMain = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
        <Col sm={6}>
          <NFTextInput fieldName={"description"} title={t("Description")} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} />
        </Col>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} />
        </Col>
        <Col sm={6}>
          <NFLookupDivision fieldName={"divisionId"} title={t("Division")} companyId={watch('companyId')}/>
        </Col>
      </Row>
    </>
  );
};

export default WarehouseDetailMain;
